var _defs, _path, _path2, _path3, _path4, _path5, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95.385 131.07",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24.29,
    x2: 140.67,
    y1: 24.097,
    y2: 108.75,
    gradientTransform: "scale(.85158 1.1743)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.08,
    offset: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.02,
    offset: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m106.69 35.274c-0.186-1.0977-0.967-2-2.0244-2.338s-2.2148-0.057-3.0002 0.73l-15.415 15.5-12.12-23.146c-0.5133-0.9786-1.525-1.5914-2.6273-1.5914s-2.114 0.6128-2.6273 1.5914l-6.6277 12.656-16.625-31.104c-0.603-1.1297-1.8588-1.746-3.118-1.5297s-2.2394 1.216-2.4335 2.4827l-16.068 103.18 42.973 24.165c2.6985 1.5113 5.985 1.5113 8.6836 0l43.344-24.165-12.313-76.427z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0.052 105.75 16.132-103.23c0.1972-1.266 1.1818-2.264 2.445-2.4786s2.522 0.4028 3.126 1.5327l16.684 31.117 6.65-12.662c0.515-0.979 1.5303-1.592 2.6366-1.592s2.1215 0.613 2.6366 1.592l45.023 85.718h-95.333z",
    fill: "#ffa000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m55.785 65.538-17.354-32.86-38.379 73.072z",
    fill: "#f57c00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m95.385 105.75-12.356-76.46c-0.1867-1.098-0.9703-2-2.0315-2.34s-2.2226-0.057-3.0107 0.7302l-77.935 78.069 43.123 24.183c2.708 1.512 6.006 1.512 8.714 0l43.496-24.183z",
    fill: "#ffca28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m83.029 29.289c-0.1867-1.098-0.9703-2-2.0315-2.34s-2.2226-0.057-3.0107 0.7302l-15.468 15.508-12.164-23.156c-0.515-0.979-1.5303-1.592-2.6366-1.592s-2.1215 0.613-2.6366 1.592l-6.65 12.662-16.684-31.117c-0.605-1.1302-1.8653-1.7466-3.13-1.5304s-2.246 1.2167-2.441 2.4837l-16.125 103.22h-0.052l0.052 0.0596 0.4245 0.2085 77.488-77.578c0.7877-0.7915 1.952-1.076 3.016-0.737s1.849 1.2445 2.0338 2.3457l12.252 75.775 0.1192-0.0745-12.356-76.46zm-82.836 76.319 15.991-102.35c0.1948-1.267 1.1784-2.2675 2.442-2.4837s2.524 0.4 3.13 1.5304l16.682 31.117 6.65-12.662c0.515-0.979 1.5303-1.592 2.6366-1.592s2.1215 0.613 2.6366 1.592l11.917 22.664-62.086 62.183z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m51.89 129.2c-2.708 1.512-6.006 1.512-8.714 0l-43.019-24.116-0.1043 0.663 43.123 24.176c2.708 1.512 6.006 1.512 8.714 0l43.496-24.176-0.1117-0.6852-43.384 24.139z",
    fill: "#a52714",
    opacity: 0.2
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-23.781 -5.9698)",
    width: "100%",
    height: "100%",
    fill: "url(#a)",
    xlinkHref: "#b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.4948b1b386c541f5fafeace3c00adb0a.svg";
export { ForwardRef as ReactComponent };